import React, { useState } from 'react';
import HeaderLiveButton from './HeaderLiveButton';

function Header({ setActiveScreen, isLive, countdownText, onInstallClick, showInstallButton, needRefresh, onUpdate, currentUser, onLogout }) {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateButtonClick = () => {
    setIsUpdating(true);
    onUpdate();
  };

  return (
    <div className="header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', background: 'rgba(10, 10, 10, 0.95)', borderBottom: '1px solid rgba(255, 255, 255, 0.08)', boxSizing: 'border-box', gap: '12px', width: '100%' }}>
      <div className="header-content-left" style={{ flex: 1, minWidth: 0 }}>
        <p className="tagline" style={{ margin: 0, fontSize: '12px', color: '#AAA', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Caribbean Content to a Global Stage.</p>
        <p className="headerTitle" style={{ fontFamily: "'Alfa Slab One', serif", fontSize: '28px', fontWeight: 'normal', color: '#FFD700', margin: '4px 0 8px 0', wordSpacing: '8px', letterSpacing: '0.5px', textShadow: '2px 2px 4px rgba(0,0,0,0.6)' }}>NVA Network</p>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <HeaderLiveButton 
              setActiveScreen={setActiveScreen} 
              isLive={isLive} 
              countdownText={countdownText} 
          />
          
          {showInstallButton && (
            <button
              onClick={onInstallClick}
              style={{
                backgroundColor: '#FFD700', color: '#0A0A0A', border: 'none',
                borderRadius: '16px', padding: '5px 12px', fontWeight: 'bold',
                cursor: 'pointer', fontSize: '11px', display: 'flex',
                alignItems: 'center', gap: '6px'
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
              <span>Install App</span>
            </button>
          )}

          {!showInstallButton && needRefresh && (
            <button
              onClick={handleUpdateButtonClick}
              disabled={isUpdating}
              style={{
                backgroundColor: '#FFD700', color: '#0A0A0A', border: 'none',
                borderRadius: '16px', padding: '5px 12px', fontWeight: 'bold',
                cursor: 'pointer', fontSize: '11px', display: 'flex',
                alignItems: 'center', gap: '6px'
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path></svg>
              <span>{isUpdating ? 'Updating...' : 'Update App'}</span>
            </button>
          )}
        </div>
      </div>
      
      {/* CLEAN IN-FLOW CONTROLS (NO ABSOLUTE OVERLAP) */}
      <div className="header-right-group" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
        <img
          src="https://firebasestorage.googleapis.com/v0/b/nvanetworkapp.firebasestorage.app/o/NVA%20Network%20LOGO%203_BRIGHT%20BG.png?alt=media&token=95b8d741-2fbd-4fc1-af2f-42b95ff20eb1"
          alt="NVA Network Logo"
          className="headerLogo"
          style={{ width: '48px', height: 'auto', objectFit: 'contain' }}
        />
        {currentUser ? (
          <button
            onClick={onLogout}
            style={{
              backgroundColor: '#FFD700', color: '#0A0A0A', padding: '3px 12px',
              borderRadius: '20px', border: 'none', fontWeight: '900',
              fontSize: '10px', cursor: 'pointer', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.4)',
              textAlign: 'center', textTransform: 'uppercase'
            }}
          >
            Exit
          </button>
        ) : (
          <button
            onClick={() => setActiveScreen('Login')}
            style={{
              backgroundColor: 'transparent', color: '#00FFFF', padding: '3px 12px',
              borderRadius: '20px', border: '1.5px solid #00FFFF', fontWeight: '900',
              fontSize: '10px', cursor: 'pointer', textAlign: 'center', textTransform: 'uppercase'
            }}
          >
            Login
          </button>
        )}
      </div>
    </div>
  );
}

export default Header;